"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeout = exports.keepTrying = exports.sleep = void 0;
/**
 * sleep for ms
 */
function sleep(ms) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(resolve, ms));
    });
}
exports.sleep = sleep;
/**
 * keep invoking fn, catching errors, sleeping between invocations
 */
function keepTrying(fn, retries = 3, ms = 1000) {
    return __awaiter(this, void 0, void 0, function* () {
        let e;
        for (let i = 0; i < retries; i++) {
            try {
                return yield timeout(fn, ms);
            }
            catch (_e) {
                e = _e;
                yield sleep(ms);
            }
        }
        throw new Error("failed to invoke fn " + e);
    });
}
exports.keepTrying = keepTrying;
function timeout(fn, ms = 1000) {
    return __awaiter(this, void 0, void 0, function* () {
        let failed = false;
        const r = yield Promise.race([
            fn(),
            new Promise((resolve) => {
                setTimeout(() => {
                    failed = true;
                    resolve(null);
                }, ms);
            }),
        ]);
        if (!failed && !!r)
            return r;
        else
            throw new Error("timeout");
    });
}
exports.timeout = timeout;
